<template>
  <el-dialog
    :title="$l('手写签名')"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
  >
    <div class="sign-dialog-body">
      <canvas
        ref="signCanvas"
        width="480"
        height="220"
        class="sign-canvas"
      ></canvas>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="clearCanvas">{{ $l("清除") }}</el-button>
      <el-button type="primary" @click="confirm">{{ $l("确定") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import global from "@/mixins/global.js";

export default {
  name: "sign-dialog",
  mixins: [global],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      isDrawing: false,
      lastX: 0,
      lastY: 0,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.$nextTick(() => {
          this.initCanvas();
        });
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
      if (!val) {
        this.$emit("close");
      }
    },
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.signCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 2;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      const getPos = (e) => {
        const rect = canvas.getBoundingClientRect();
        return {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top,
        };
      };
      canvas.onmousedown = (e) => {
        this.isDrawing = true;
        const pos = getPos(e);
        this.lastX = pos.x;
        this.lastY = pos.y;
      };
      canvas.onmousemove = (e) => {
        if (!this.isDrawing) return;
        const pos = getPos(e);
        ctx.beginPath();
        ctx.moveTo(this.lastX, this.lastY);
        ctx.lineTo(pos.x, pos.y);
        ctx.stroke();
        this.lastX = pos.x;
        this.lastY = pos.y;
      };
      canvas.onmouseup = () => {
        this.isDrawing = false;
      };
      canvas.onmouseleave = () => {
        this.isDrawing = false;
      };
    },
    clearCanvas() {
      const canvas = this.$refs.signCanvas;
      if (canvas) {
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    },
    confirm() {
      const canvas = this.$refs.signCanvas;
      if (canvas) {
        this.$emit("confirm", canvas.toDataURL("image/png"));
        this.clearCanvas();
      }
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.sign-dialog-body {
  display: flex;
  justify-content: center;
  padding: 10px 0;
  .sign-canvas {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    cursor: crosshair;
    touch-action: none;
  }
}
.dialog-footer {
  text-align: right;
  display: block;
}
</style>
